import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { defaultProfileImage } from "../../../utils/constants";
import { sanitizeHtml } from "../../../helpers/sanitizeHtml";
import { CommunityDiscussion } from "../models/CommunityDiscuss";

interface Props extends CommunityDiscussion {
    onEnter: (id: number) => void;
    onArchive: (id: number) => void;
    onEdit: (id:number) => void;
}

export const CommunityDiscussionsItem = ({ host, notifications, avatar, author, title, tags: sections, details, comments, members, memberComments, onEnter, onArchive, onEdit,  id }: Props) => {

    return (
        <div className="community-discussions">
            <div className="community-discussions__author">
                <img src={avatar || defaultProfileImage } onError={(e) => { e.currentTarget.src = defaultProfileImage }} alt={author} />
                <span className="author">
                    {host ? 'You': author}
                </span>

                { host &&
                    <>
                        <div className="host">
                            <span>Host</span>
                        </div>


                        <div className="actions">
                            <button onClick={() => onEdit(id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M8.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V9.75" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12.03 2.26592L6.11997 8.17591C5.89497 8.40091 5.66997 8.84341 5.62497 9.16591L5.30247 11.4234C5.18247 12.2409 5.75997 12.8109 6.57747 12.6984L8.83497 12.3759C9.14997 12.3309 9.59247 12.1059 9.82497 11.8809L15.735 5.97092C16.755 4.95092 17.235 3.76592 15.735 2.26592C14.235 0.765922 13.05 1.24592 12.03 2.26592Z" stroke="#151515" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.1825 3.11328C11.685 4.90578 13.0875 6.30828 14.8875 6.81828" stroke="#151515" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>

                            <button onClick={() => onArchive(id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M14.625 7.66406V14.2491C14.625 15.7491 14.25 16.4991 12.375 16.4991H5.625C3.75 16.4991 3.375 15.7491 3.375 14.2491V7.66406" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M3.75 1.5H14.25C15.75 1.5 16.5 2.25 16.5 3.75V5.25C16.5 6.75 15.75 7.5 14.25 7.5H3.75C2.25 7.5 1.5 6.75 1.5 5.25V3.75C1.5 2.25 2.25 1.5 3.75 1.5Z" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.63501 10.5H10.365" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </> 
                }
            </div>
            <div className="community-discussions__details">
                <div className="title">
                    <label>{title}</label>
                    { !!notifications && notifications > 0 && <div>{notifications}</div>  }
                </div>
                <div className="community-discussions-sections">
                    {sections.map((s, i) => (
                        <span key={i}>{s}</span>
                    ))}
                </div>
                
                <p style={{ maxHeight: '12px', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: sanitizeHtml(details) }}></p>
            </div>
            <div className="community-discussions__reactions">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M6.375 7.875H11.625" stroke="#B4B4B4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.25 13.8242H8.25L11.5875 16.0443C12.0825 16.3743 12.75 16.0217 12.75 15.4217V13.8242C15 13.8242 16.5 12.3242 16.5 10.0742V5.57422C16.5 3.32422 15 1.82422 12.75 1.82422H5.25C3 1.82422 1.5 3.32422 1.5 5.57422V10.0742C1.5 12.3242 3 13.8242 5.25 13.8242Z" stroke="#B4B4B4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {comments}
                </div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9 9C11.071 9 12.75 7.32106 12.75 5.25C12.75 3.17893 11.071 1.5 9 1.5C6.92893 1.5 5.25 3.17893 5.25 5.25C5.25 7.32106 6.92893 9 9 9Z" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.4426 16.5C15.4426 13.5975 12.5551 11.25 9.00011 11.25C5.44512 11.25 2.55762 13.5975 2.55762 16.5" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {`${memberComments} `} Members
                </div>

                <div className="actions">
                    <button onClick={() => onEnter(id)}>
                        Enter
                    </button>
                    {host && 
                        <button onClick={() => onEdit(id)}>
                            Invite People
                        </button>
                    }
                </div>
            </div>
        </div>
    )
}